import { PropsWithRef, Ref, forwardRef } from 'react';
import { CheckboxProps } from './types';
import { Checkbox as JuicyCheckbox, FormGroup } from '@vtbhome/juicyfront';
import { Typography } from '../typography/typography';

export const Checkbox = forwardRef(
    ({ error, ...props }: PropsWithRef<CheckboxProps>, ref: Ref<HTMLLabelElement | null>) => {
        return (
            <FormGroup
                errorMessage={
                    <Typography size='body2_short' color='error_60'>
                        {error}
                    </Typography>
                }>
                <JuicyCheckbox ref={ref} {...props} />
            </FormGroup>
        );
    }
);

Checkbox.displayName = 'Checkbox';
